module.exports = __webpack_public_path__ + "img/Paper shape.629bbf82.svg";